import React from 'react'
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from "react-bootstrap";
import "./Footer.css"

function Index() {
  return (
    <>
      <footer className="footer-section py-5 px-lg-5 px-md-3 px-sm-3 px-xs-1">
        <Container fluid className="footer-section-sub px-5 pt-4">
          <Row className="text-md-start">
            {/* Company Info */}
            <Col lg={4} md={6} sm={12} className="mb-4">
              <h5 className="footer-title text-start">lankalearners.lk / SLDL APPs </h5>
              <p className="footer-text text-start">
                We are committed to creating a community of good drivers in Sri Lanka who are law-abiding and disciplined.
              </p>
            </Col>

            <Col lg={1} md={6} sm={12} className="mb-4"></Col>

            {/* Contact Info */}
            <Col lg={3} md={6} sm={12} className="mb-4">
              <h4 className="text-start">Contact Us</h4>
              <p className="text-start">
                <strong>Phone</strong>
                <br />
                +94 71 236 7846
              </p>
              <p className="text-start">
                <strong>Email</strong>
                <br />
                <a href="mailto:lankalearners59@gmail.com" style={{ color: "#FFFFFF" }}>
                  lankalearners59@gmail.com
                </a>
              </p>
              <p className="text-start">
                <strong>Address</strong>
                <br />
                No. 100/1, Dumbara Uyana,
                <br /> Balagolla, Kengalla
              </p>
            </Col>

            {/* Subscribe Newsletter */}
            <Col lg={4} md={6} sm={12} className="px-2">
              <h4 className="footer-title text-start">Subscribe Newsletter</h4>
              <p className="footer-text text-start">
                Subscribe to our newsletter to get updates about our services
                and offers
              </p>
              <Form>
                <Form.Group className="d-flex">
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                    style={{
                      borderRadius: "20px 0 0 20px",
                      border: "none",
                      height: "50px",
                    }}
                  />
                  <Button
                    className="subscribe-button"
                    variant="primary"
                    style={{
                      width: "100px",
                      height: "50px",
                      borderRadius: "0px 20px 20px 0px",
                      backgroundColor: "#CF2012",
                      border: "none",
                    }}
                  >
                    &#x27A4;
                  </Button>
                </Form.Group>
              </Form>
            </Col>
          </Row>
          <Row className="d-md-flex justify-content-between text-center text-md-start">
            <div className="footer-bottom col-12 col-md-6 mt-3">
              <p>
                <a
                  href="https://mecsit.com/"
                  className="text-white text-decoration-none"
                  alt="MECHSIT"
                >
                  © 2024 MECHSIT (PVT) LTD
                </a>
                . All Rights Reserved.
              </p>
            </div>
            <div className="footer-bottom col-12 col-md-6 mt-3 text-center text-md-end">
              <p className="text-white">
                <a
                  href="/Privacy-Policy"
                  className="text-white text-decoration-none me-2"
                  alt="Privacy Policy"
                >
                  Privacy Policy
                </a>
                <span className="mx-2">|</span>
                <a
                  href="/Terms-&-Conditions"
                  className="text-white text-decoration-none ms-2"
                  alt="Terms and Conditions"
                >
                  Terms & Conditions
                </a>
                <span className="mx-2">|</span>
                <a
                  href="/Return-Policy"
                  className="text-white text-decoration-none ms-2"
                  alt="Return Policy"
                >
                  Return Policy
                </a>
              </p>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default Index
